var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.is_set_data
      ? _c(
          "div",
          { staticClass: "redraw_block" },
          [
            _c("info_field", {
              attrs: {
                f_uniq: "ct3",
                f_type: "group_name",
                is_disabled: true,
                f_title: _vm.__t("ROLE.TG_UID"),
                f_val: _vm.cur_item.user_uid,
              },
            }),
            _vm._v(" "),
            _c("info_field", {
              attrs: {
                f_uniq: "ct3",
                f_type: "username_tg",
                is_disabled: true,
                f_title: _vm.__t("ROLE.TG_USERNAME"),
                f_val: "@" + _vm.cur_item.tg_user.username,
              },
            }),
            _vm._v(" "),
            _c("info_field", {
              attrs: {
                f_uniq: "ct3",
                f_type: "username_tg_alias",
                is_disabled: false,
                f_title: _vm.__t("ROLE.TG_ALIAS_NAME"),
                f_val: _vm.cur_item.tg_user.alias_name || "",
              },
              on: {
                input: function (val) {
                  return _vm.change_atr("alias_name", val)
                },
              },
            }),
            _vm._v(" "),
            _c("info_field", {
              attrs: {
                f_uniq: "ct3",
                f_type: "real_name",
                is_disabled: true,
                f_title: _vm.__t("ROLE.NAME"),
                f_val:
                  _vm.cur_item.tg_user.first_name +
                  " " +
                  _vm.cur_item.tg_user.last_name,
              },
            }),
            _vm._v(" "),
            _c("info_field", {
              attrs: {
                f_uniq: "ct3",
                f_type: "created_at",
                is_disabled: true,
                f_title: _vm.__t("ROLE.TG_ADDED"),
                f_val: _vm.cur_item.tg_user.created_at,
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "allow_in" },
              [
                _c(
                  "b-row",
                  [
                    _c("b-col", [
                      _c(
                        "div",
                        [
                          _c("yes_no", {
                            key: "IS_LOCKED",
                            attrs: { title: "IS_LOCKED" },
                            on: {
                              input: function (val) {
                                return _vm.change_atr("is_locked", val)
                              },
                            },
                            model: {
                              value: _vm.cur_item.is_locked,
                              callback: function ($$v) {
                                _vm.$set(_vm.cur_item, "is_locked", $$v)
                              },
                              expression: "cur_item.is_locked",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("b-col", [
                      _c(
                        "div",
                        [
                          _c("yes_no", {
                            key: "OPERATE_LOCATION_STATUS",
                            attrs: { title: "OPERATE_LOCATION_STATUS" },
                            on: {
                              input: function (val) {
                                return _vm.change_atr(
                                  "is_operate_location_status",
                                  val
                                )
                              },
                            },
                            model: {
                              value: _vm.cur_item.is_operate_location_status,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.cur_item,
                                  "is_operate_location_status",
                                  $$v
                                )
                              },
                              expression: "cur_item.is_operate_location_status",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("b-col", [
                      _c(
                        "div",
                        [
                          _c("yes_no", {
                            key: "OPERATE_ORDER_STATUS",
                            attrs: { title: "OPERATE_ORDER_STATUS" },
                            on: {
                              input: function (val) {
                                return _vm.change_atr(
                                  "is_operate_order_status",
                                  val
                                )
                              },
                            },
                            model: {
                              value: _vm.cur_item.is_operate_order_status,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.cur_item,
                                  "is_operate_order_status",
                                  $$v
                                )
                              },
                              expression: "cur_item.is_operate_order_status",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.notification_groups.length
      ? _c(
          "div",
          { staticClass: "mt-4" },
          [
            _c("h5", { staticClass: "fw-700 mb-3" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.__t("ROLE.NOTIFICATIONS")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c(
              "b-tabs",
              { attrs: { pills: "", card: "", vertical: "" } },
              _vm._l(
                _vm.groupedNotificationGroups,
                function (items, groupType, index) {
                  return _c(
                    "b-tab",
                    {
                      key: "notif_tab_" + groupType,
                      attrs: { active: index === 0 },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.__t(
                                        "TG_NOTIF." + groupType.toUpperCase()
                                      )
                                    ) +
                                    "\n                "
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "list-group" },
                        _vm._l(items, function (group) {
                          return _c(
                            "div",
                            {
                              key: "notif_" + group.id,
                              staticClass:
                                "list-group-item d-flex align-items-center justify-content-between",
                            },
                            [
                              _c("div", [
                                _c("div", { staticClass: "fw-600" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.__t(group.user_name)) +
                                      "\n                            "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(group.type) +
                                      "\n                            "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "custom-control custom-switch" },
                                [
                                  _c("input", {
                                    staticClass: "custom-control-input",
                                    attrs: {
                                      id: "tg-notif-" + group.id,
                                      type: "checkbox",
                                    },
                                    domProps: {
                                      checked: _vm.isNotificationEnabled(
                                        group.id
                                      ),
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.toggleNotification(
                                          group.id,
                                          $event.target.checked
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("label", {
                                    staticClass: "custom-control-label",
                                    attrs: { for: "tg-notif-" + group.id },
                                  }),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  )
                }
              ),
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }